<template>
	<div class="sa-utility-page-wrapper">
		<div class="sa-articolo-card">
			<div class="sa-utility-header">
				<div style="flex: 1">
					<h2 class="h4 mb-1 font-weight-bold">{{ jsonData.descrizione }}</h2>
					<small class="sa-articolo-text-muted">
						Codice A.T.C.: <strong>{{ jsonData.codiceProdotto }}</strong>
					</small>
					<small class="sa-articolo-text-muted">
						Codice ATC: <strong>{{ jsonData.atcGmp }}</strong>
					</small>
				</div>
				<div style="flex: 1">
					<div class="text-right">
						<span class="sa-utility-label">Classe Farmaco</span>
						<b-badge pill variant="dark" style="font-size: 1.1rem">{{ jsonData.classe1 }}</b-badge>
					</div>
				</div>
			</div>
			<b-row class="mb-4">
				<b-col xs="12" sm="12" md="12" lg="12" xl="12" class="mb-3">
					<div class="sa-utility-section"><i class="fas fa-capsules" style="color: var(--bg-sidebar); font-size: 16px"></i> <span class="sa-articolo-section-title">Dettaglio Farmaco</span></div>
				</b-col>
			</b-row>

			<b-row class="mb-4">
				<b-col md="6" class="mb-4">
					<div class="sa-articolo-active-box">
						<span class="sa-utility-label">Principio Attivo</span>
						<span class="sa-utility-value text-primary h5 mb-0">{{ jsonData.principioAttivoFarmaco.descrizione }} </span>
					</div>
				</b-col>
				<b-col md="6" class="mb-4">
					<span class="sa-utility-label">Forma Farmaceutica</span>
					<span class="sa-utility-value">{{ jsonData.formaFarmaceutica.descrizioneEstesa }}</span>
				</b-col>

				<b-col md="3" class="mb-3">
					<span class="sa-utility-label">Tipo Ricetta</span>
					<span class="sa-utility-value">{{ jsonData.tipoRicetta1 }}</span>
				</b-col>
				<b-col md="3" class="mb-3">
					<span class="sa-utility-label">Mesi Scadenza</span>
					<span class="sa-utility-value">{{ jsonData.mesiScadenza }} mesi</span>
				</b-col>
				<b-col md="6" class="mb-3">
					<span class="sa-utility-label">Gruppo Terapeutico</span>
					<span class="sa-utility-value">{{ jsonData.gruppoTerapeuticiBean.descrizione }} </span>
				</b-col>

				<b-col md="6" class="mb-3">
					<span class="sa-utility-label">Regimi SSN</span>
					<b-badge variant="light" class="border text-secondary">{{ jsonData.regimeSsn1Bean.descrizioneEstesa }}</b-badge>
				</b-col>
				<b-col md="6" class="mb-3">
					<span class="sa-utility-label">Classificazione ATC</span>
					<span class="sa-utility-value">{{ jsonData.atcClassificazione.descrizione }} ({{ jsonData.atcClassificazione.codiceElemento }})</span>
				</b-col>
			</b-row>

			<div class="sa-articolo-divider"></div>
			<b-row class="mb-4">
				<b-col xs="12" sm="12" md="12" lg="12" xl="12" class="mb-3">
					<div class="sa-utility-section"><i class="fas fa-tag" style="color: var(--bg-sidebar); font-size: 16px"></i> <span class="sa-articolo-section-title">Tipo Prodotto</span></div>
				</b-col>
			</b-row>
			<b-row class="mb-4">
				<b-col md="4">
					<span class="sa-utility-label">Descrizione Prodotto</span>
					<span class="sa-utility-value">{{ jsonData.tipoProdottoBean.descrizioneEstesa }}</span>
				</b-col>
				<b-col md="4">
					<span class="sa-utility-label">Tipo Elemento</span>
					<b-badge variant="outline-secondary">{{ jsonData.tipoProdottoBean.tipoElemento }}</b-badge>
				</b-col>
				<b-col md="4">
					<span class="sa-utility-label">Elemento Attivo</span>
					<span class="sa-utility-value">{{ jsonData.tipoProdottoBean.elementoAttivo }}</span>
				</b-col>
			</b-row>

			<div class="sa-articolo-divider"></div>

			<b-row class="mb-4">
				<b-col xs="12" sm="12" md="12" lg="12" xl="12" class="mb-3">
					<div class="sa-utility-section"><i class="fas fa-industry" style="color: var(--bg-sidebar); font-size: 16px"></i> <span class="sa-articolo-section-title">Ditta Produzione</span></div>
				</b-col>
			</b-row>
			<b-row>
				<b-col md="4" class="mb-3">
					<span class="sa-utility-label">Ragione Sociale</span>
					<span class="sa-utility-value">{{ jsonData.ditta.ragioneSociale }}</span>
				</b-col>
				<b-col md="4" class="mb-3">
					<span class="sa-utility-label">Codice Fiscale</span>
					<span class="sa-utility-value font-mono">{{ jsonData.ditta.codiceFiscale }}</span>
				</b-col>
				<b-col md="4" class="mb-3">
					<span class="sa-utility-label">Località</span>
					<span class="sa-utility-value">{{ jsonData.ditta.citta1 }} ({{ jsonData.ditta.provincia1 }})</span>
				</b-col>
				<b-col md="4">
					<span class="sa-utility-label">Telefono</span>
					<span class="sa-utility-value"><i class="fas fa-phone-alt mr-2 text-muted"></i>{{ jsonData.ditta.telefono1 }}</span>
				</b-col>
				<b-col md="8">
					<span class="sa-utility-label">Email Supporto</span>
					<span class="sa-utility-value text-primary">{{ jsonData.ditta.email1 || "n.d." }}</span>
				</b-col>
			</b-row>
		</div>
		<sa-modal-loading ref="mdlSaModalLoading"></sa-modal-loading>
		<modal-error ref="cmpModalError"></modal-error>
	</div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import { SaModalLoading } from "../../utility";
export default {
	mixins: [UtilityMixin],
	components: { ModalError, SaModalLoading },
	// props: { id: { type: String } },
	data() {
		return {
			pathResource: "/farmaci",
			showModalLoading: false,
			listKey: 0,
			rows: 0,
			perPage: 50,
			currentPage: 1,
			id: null,
			// id: "987417666",
			jsonData: { ditta: {}, atcClassificazione: {}, formaFarmaceutica: {}, farmacoPrescrivibilita: {}, principioAttivoFarmaco: {}, gruppoTerapeuticiBean: {}, tipoProdottoBean: {}, regimeSsn1Bean: {}, regimeSsn2Bean: {}, listaMonografia: [] },
			sezioniMonografia: null,
			itemsMonografia: [],
		};
	},
	mounted() {},
	watch: {},
	methods: {
		init(id) {
			let me = this;
			me.id = id;
			me.loadData();
		},
		loadData() {
			let me = this;
			this.$refs.mdlSaModalLoading.show();
			me.loadDataResources(me.pathResource + "/" + me.id, {}, me.resultResponseLoaData, me.resulErrorLoadData);
		},
		resultResponseLoaData(response) {
			let me = this;
			me.jsonData = response.data.data;
			if (me.jsonData.listaMonografia.length > 0) {
				me.buildMonografia(me.jsonData.listaMonografia);
			}
			this.$refs.mdlSaModalLoading.close();
		},
		resulErrorLoadData(error) {
			let me = this;
			me.$refs.cmpModalError.show(error.response.data.messaggio);
			this.$refs.mdlSaModalLoading.close();
		},
		buildMonografia(array) {
			let me = this;
			me.sezioniMonografia = {};
			me.itemsMonografia = [];
			array.forEach((element) => {
				if (!me.sezioniMonografia[element.descrizioneSezione]) {
					me.sezioniMonografia[element.descrizioneSezione] = { sezione: element.descrizioneSezione, testo: "" };
				}
				me.sezioniMonografia[element.descrizioneSezione].testo += element.testo + " ";
			});
			me.itemsMonografia = Object.values(me.sezioniMonografia);
		},
	},
};
</script>
<style>
.sa-articolo-wrapper {
	background-color: #f8f9fa;
	/* min-height: 100vh; */
	padding: 2rem 0;
	font-family: "Inter", sans-serif;
}
.sa-articolo-card {
	border: none;
	border-radius: 15px;
	box-shadow: none;
}

/* Stile intestazione sezioni */
.sa-articolo-section-title {
	padding: 10px 15px;
	border-radius: 8px;
	font-size: 0.85rem;
	font-weight: 800;
	color: #475569;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin-bottom: 20px;
	align-items: center;
}
.sa-articolo-section-title i {
	margin-right: 10px;
	color: #007bff;
}

/* Campi dati */
.sa-articolo-label {
	font-size: 0.7rem;
	text-transform: uppercase;
	color: #94a3b8;
	font-weight: 700;
	display: block;
	margin-bottom: 2px;
}
.sa-articolo-value {
	font-size: 0.95rem;
	color: #1e293b;
	font-weight: 600;
	display: block;
}

/* Box evidenziato per Principio Attivo */
.sa-articolo-active-box {
	background-color: #e0f2fe;
	border: 1px solid #bae6fd;
	padding: 15px;
	border-radius: 10px;
}

.sa-articolo-divider {
	border-top: 1px solid #e2e8f0;
	margin: 25px 0;
}
</style>
